'use client';

var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-page-content/index.jsx",
    _this = this;

import React from 'react';
import styled from 'styled-components';
import { Heading, Page, PageTitle, Paragraph, spaceMixin } from '@zillow/constellation';
import IncomeDebtForm from '../mrac-income-debt-form';
var PageWithPadding = styled(Page).withConfig({
  displayName: "mrac-page-content__PageWithPadding",
  componentId: "sc-o46w2t-0"
})(["padding:", ";"], spaceMixin('xl'));

var MRACPageContent = function MRACPageContent() {
  return /*#__PURE__*/React.createElement(PageWithPadding, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(PageTitle, {
    heading: /*#__PURE__*/React.createElement(Heading, {
      level: 1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 22
      }
    }, "Rent Affordability Calculator"),
    marginX: "0",
    paddingX: "0",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Paragraph, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, "This calculator shows rentals that fit your budget. Savings, debt, and other expenses could impact the amount you want to spend on rent each month. Input your net (after tax) income and the calculator will display rentals up to 40% of your estimated gross income. Property managers typically use gross income to qualify applicants, so the tool assumes your net income is taxed at 25%. Actual tax rates vary."), /*#__PURE__*/React.createElement(IncomeDebtForm, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }));
};

export default MRACPageContent;